import {useQuery} from 'react-query'
import {fetchStudentDailyTrip} from '../../app/pages/liveTrip/api'
import {Error500} from '../../app/modules/errors/components/Error500'
import {RunnerBall} from '../FormLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import StudentsInDailyTripTable from './StudentsInDailyTripTable'
import viewProps from '../../app/pages/viewProps'

interface StudentsInDailyTripProps {
  dailyTripId: string | number
}

function StudentsInDailyTrip({dailyTripId}: StudentsInDailyTripProps) {
  const {data, isLoading, isError, isFetching} = useQuery(
    ['student_daily_trip', dailyTripId],
    () => fetchStudentDailyTrip(dailyTripId), // Use `dailyTripId` directly here
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <RunnerBall />
  }

  if (isError) {
    return (
      <div className="text-center">
        <Error500 />
      </div>
    )
  }
  return (
    <>
      <StudentsInDailyTripTable
        studentData={data?.data || []}
        fieldsToLableMap={viewProps.StudentsInDailyTrip.primaryFieldsToLabelMap}
      />
      {isFetching && <TopBarProgress />}
    </>
  )
}

export default StudentsInDailyTrip
